import Swiper from 'swiper'
import registerFCInstagram from './instagramCodigoBase'

export default function instagramApi() {
	const instaWrapper = document.querySelector('#instafeed')
	if (!instaWrapper) return

	registerFCInstagram()

	jQuery.fn.FCInstagram.accessData = {
		accessToken:
			'IGAASPEiRjZBYFBZAGJpT1BnMW5zTDc3eTdjdjdzSmVwMzltMkx5YUxFQmVPRHAxV1RSelNseDhWLVVFQkRTSmNvR3dqTUJmMkRrcHdMb2xGQ2pOR1JIbFlwenZAEYTBTckJCVlRreWtJQ1g1ZAmxjNHJSNVU4bWdoVmxCVGtubnJSawZDZD',
	}

	$('#instafeed').FCInstagram({
		max: 10,
		autoplay: true,
		complete: function () {
			const instaItems = document.querySelectorAll('#instafeed a')

			const htmlSlide = [...instaItems]
				.map((item) => {
					return `
                <div class="swiper-slide">
                        <span style="visibility:hidden">-</span>
                        <div>
                            ${item.outerHTML}    
                            <div class="content">
                            <svg>
                                <use xlink:href="#icon_instagram_white"></use>
                            </svg>
                            <span class="text-white">Ver no instagram</span>
                            </div>
                        </div>
                </div>
                `
				})
				.join('')

			instaWrapper.innerHTML = `          
            <div class="swiper swiper-acompanhe-nos" style="display: grid; width:100%;">
                <div class="swiper-wrapper">
                ${htmlSlide}
                </div>
            </div>
            `

			new Swiper('.swiper-acompanhe-nos', {
				lazy: true,
				slidesPerView: 'auto',
				spaceBetween: 8,
				centeredSlides: true,
				centeredSlidesBounds: true,
			})
		},
	})
}
